import React from "react";
import { Avatar } from "@mui/material";
import { Box } from "@mui/system";

interface UserAvatarProps {
  firstName: string;
  lastName: string;
  color: string;
  isFromPipeline?: boolean;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ firstName, lastName, color, isFromPipeline }) => {
  const getUserInitials = (first: string, last: string) => {
    if (!first || !last) return "";
    return `${first[0]}${last?.trim()[0]}`.toUpperCase();
  };

  return (
    <Avatar
      sx={{
        width: isFromPipeline ? `30 !important` : 37,
        height: isFromPipeline ? `30 !important` : 37,
        backgroundColor: `${color} !important`,
        fontSize: isFromPipeline ? 13 : 16,
        fontWeight: isFromPipeline ? "bold" : "normal",
        marginRight: "-5px",
      }}
    >
      {getUserInitials(firstName, lastName)}
    </Avatar>
  );
};

UserAvatar.defaultProps = {
  isFromPipeline: false,
};

export default UserAvatar;
